import {createSelector} from "reselect";
import {initialState} from "./reducer";

/**
 * Direct selector to the timeSlotPage state domain
 */

const selectTimeSlotPageDomain = state =>
  state.get("timeSlotPage", initialState);

/**
 * Other specific selectors
 */
export const makeSelectTimeSlot = () =>
  createSelector(selectTimeSlotPageDomain, subState => {
    const timeSlot = subState.get("timeSlot");
    if (!timeSlot) {
      return null;
    }
    if (!timeSlot.plannedTreatments) {
      timeSlot.plannedTreatments = [];
    }
    return timeSlot;
  });

export const makeSelectTimeSlotLoading = () =>
  createSelector(selectTimeSlotPageDomain, subState =>
    subState.get("timeSlotLoading"),
  );

export const makeSelectDeleted = () =>
  createSelector(selectTimeSlotPageDomain, subState => subState.get("deleted"));

export const makeSelectDeleteLoading = () =>
  createSelector(selectTimeSlotPageDomain, subState =>
    subState.get("deleteLoading"),
  );

export const makeSelectDeleteTimeSlotLoading = () =>
  createSelector(selectTimeSlotPageDomain, subState =>
    subState.get("deleteTimeSlotLoading"),
  );

export const makeSelectTimeSlotEditFailed = () =>
  createSelector(selectTimeSlotPageDomain, subState =>
    subState.get("timeSlotEditFailed"),
  );

export const makeSelectTimeSlotEditing = () =>
  createSelector(selectTimeSlotPageDomain, subState =>
    subState.get("timeSlotEditing"),
  );


export const makeSelectPlannedDay = () =>
  createSelector(selectTimeSlotPageDomain, subState => {
    let day = subState.get("plannedDays");
    if (!day) {
      day = {};
    }

    if (!day.plannedTreatments) {
      day.plannedTreatments = [];
    }
    if (!day.plannedTimeSlots) {
      day.plannedTimeSlots = [];
    }
    return day;
  });

export const makeSelectPlannedDayLoading = () =>
  createSelector(selectTimeSlotPageDomain, subState =>
    subState.get("plannedDaysLoading"),
  );

export const makeSelectMovingTreatment = () =>
  createSelector(selectTimeSlotPageDomain, subState =>
    subState.get("movingTreatment"),
  );

export const makeSelectMovingTreatmentError = () =>
  createSelector(selectTimeSlotPageDomain, subState =>
    subState.get("movingTreatmentError"),
  );

/**
 * Default selector used by TimeSlotPage
 */

const makeSelectTimeSlotPage = () =>
  createSelector(selectTimeSlotPageDomain, subState => subState.toJS());

export default makeSelectTimeSlotPage;
export { selectTimeSlotPageDomain };
